import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Fetch/REGISTRATION_ERROR',
    PENDING: 'Fetch/REGISTRATION_PENDING',
    SUCCESS: 'Fetch/REGISTRATION_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
